// test1312
(1312 && 0);
